import { render, staticRenderFns } from "./Examination.vue?vue&type=template&id=23f7e5c1&scoped=true&"
import script from "./Examination.vue?vue&type=script&lang=js&"
export * from "./Examination.vue?vue&type=script&lang=js&"
import style0 from "./Examination.vue?vue&type=style&index=0&id=23f7e5c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f7e5c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCheckbox,VCol,VRow,VSlideYTransition})
